import _slicedToArray from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { conditionConstants } from '../constants';
var operatorMap = {
  '=': function _(a, b) {
    return a === b;
  },
  '!=': function _(a, b) {
    return a !== b;
  },
  '<': function _(a, b) {
    return a < b;
  },
  '>': function _(a, b) {
    return a > b;
  },
  '<=': function _(a, b) {
    return a <= b;
  },
  '>=': function _(a, b) {
    return a >= b;
  },
  'OR': function OR(a, b) {
    return !!a || !!b;
  },
  'AND': function AND(a, b) {
    return !!a && !!b;
  }
};

var getOperandValue = function getOperandValue(operand) {
  return parseInt(operand, 10) || operand;
};

var evaluateExpression = function evaluateExpression(_ref, operator) {
  var _ref2 = _slicedToArray(_ref, 2),
      operand1 = _ref2[0],
      operand2 = _ref2[1];

  var op1 = operand1;
  var op2 = getOperandValue(operand2);
  var res = operatorMap[operator](op1, op2);
  return res;
};

var popOperands = function popOperands(stack) {
  var op2 = stack.pop();
  var op1 = stack.pop();
  return [op1, op2];
};

var evaluatePostfixCondition = function evaluatePostfixCondition() {
  var postfixNotation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fieldValueSelector = arguments.length > 1 ? arguments[1] : undefined;
  var stack = [];

  for (var i = 0; i < postfixNotation.length; i++) {
    if (conditionConstants.operators.includes(postfixNotation[i])) {
      var operands = popOperands(stack); // Swap field id value with the actual value of the field in case it's the number and not the result of operation
      // TODO: think of a better way to differentiate result vs initial parameter(field id)

      operands[0] = typeof operands[0] === 'boolean' ? operands[0] : fieldValueSelector(operands[0]);
      var res = evaluateExpression(operands, postfixNotation[i]);
      stack.push(res);
    } else {
      stack.push(postfixNotation[i]);
    }
  }

  return stack.pop();
};

export default evaluatePostfixCondition;